import React from "react"
import DynamicSkeleton from "../../components/DynamicSkeleton"
import Skeleton from "react-loading-skeleton"

const columnConfig = {
  "Station ID": {
    content: <Skeleton height="20px" width="70px" />,
    center: true,
  },
  "User ID": {
    content: <Skeleton height="20px" width="40px" />,
    center: true,
  },
  "User Name": {
    content: <Skeleton height="20px" width="70px" />,
    center: true,
  },
  "Station Name": {
    content: <Skeleton height="20px" width="70px" />,
    center: true,
  },
  Rating: { content: <Skeleton height="20px" width="150px" />, center: true },
  Comments: { content: <Skeleton height="60px" width="200px" />, center: false },
  "Review Date / Time": {
    content: <Skeleton height="20px" width="70px" />,
    center: true,
  },
  Status: { content: <Skeleton height="30px" width="80px" />, center: true },
  Action: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="30px" width="30px" />
        <Skeleton height="30px" width="30px" />
      </div>
    ),
    center: true,
  },
}

const StationReviewSkeleton = ({ infiniteScroll, rows = 6 }) => {
  return (
    <DynamicSkeleton
      rows={rows}
      columnConfig={columnConfig}
      infiniteScroll={infiniteScroll}
    />
  )
}

export default StationReviewSkeleton
